exports.alert = (msg = '未知错误') => {
  alert(msg);
};



// WEBPACK FOOTER //
// ./src/lib/utils.js